



import LiveCreateComponent from "@/components/admin/live/liveCreateComponent.vue";
import { Component, Vue } from "vue-property-decorator";

@Component({
  name: "LiveEditPage",
  components: {
    LiveCreateComponent,
  },
})
export default class LiveEditPage extends Vue {}
